<!--
 * @Descripttion: 本次专区反馈效果评价
 * @Date: 2025-07-09 14:49:13
-->
<template>
  <div>
    <component :is="cmpName" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import * as BiTmplDetail_21_s from './components';
import { useBiTmplDetailSteup } from '../../../store';
import { storeToRefs } from 'pinia';

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const cmpName = computed(() => {
  return BiTmplDetail_21_s['BiTmplDetail_' + state.value.activeMenu[1]];
});
</script>
<style scoped lang="scss"></style>
